import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const RestorePrompt = ({ session, onRestore, onDiscard }) => {
  if (!session) return null;
  const age = Math.round((Date.now() - session.savedAt) / 60000);
  const ageText = age < 1 ? '剛才' : age < 60 ? `${age} 分鐘前` : `${Math.round(age / 60)} 小時前`;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[400] flex items-center justify-center px-6">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}
          className="absolute inset-0 bg-slate-950/90 backdrop-blur-sm" />
        <motion.div
          initial={{ opacity: 0, scale: 0.9, y: 16 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ type: 'spring', damping: 24, stiffness: 300 }}
          className="relative z-10 w-full max-w-sm bg-[#0d1a2e] border border-white/10 rounded-3xl p-6 shadow-2xl"
        >
          <div className="text-4xl text-center mb-3">⚡</div>
          <h3 className="text-lg font-black text-white text-center mb-1">發現未完成比賽</h3>
          <p className="text-sm text-white/50 text-center mb-1">{session.teamNameA} vs {session.teamNameB}</p>
          <p className="text-xs text-white/30 text-center mb-5">
            {session.scoreA} : {session.scoreB} · 第 {session.game} 局 · {ageText}
          </p>
          <div className="flex flex-col gap-2.5">
            <button onClick={onRestore}
              className="w-full py-3.5 bg-indigo-500 hover:bg-indigo-400 text-white font-black rounded-2xl transition-all active:scale-95 text-sm">
              ⚡ 繼續比賽
            </button>
            <button onClick={onDiscard}
              className="w-full py-3 bg-white/5 text-white/50 font-black rounded-2xl border border-white/10 hover:bg-white/10 transition-all active:scale-95 text-sm">
              開始新比賽
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default RestorePrompt;